
import {css, html, LitElement} from "lit"


class MssPill extends LitElement {
  static styles = css`
    *, *:before, *:after {
      box-sizing: border-box;
    }

    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #979797;
      border-radius: 10px;
      text-align: center;
      white-space: nowrap;
      padding: 2px 8px 2px 8px;
      margin: 3px;
    }
  `;

  render() {
    return html`
      <slot></slot>
    `;
  }
}
customElements.define('mss-pill', MssPill);

